import PropTypes from 'prop-types';
import {useTheme} from '@mui/material/styles';
import {Avatar, Box, ButtonBase, Hidden, Typography} from '@mui/material';
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import {IconMenu2} from '@tabler/icons-react';
import {useContext} from "react";
import {AuthContext} from "../../../context/AuthContext";
import {InfoRounded} from "@mui/icons-material";
import {Stack} from "@mui/system";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({handleLeftDrawerToggle}) => {
    const theme = useTheme();
    const {deviceId} = useContext(AuthContext);


    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <ButtonBase sx={{borderRadius: '12px', overflow: 'hidden', marginRight: 2}}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem"/>
                    </Avatar>
                </ButtonBase>
                <Box component="span" sx={{display: {xs: 'none', md: 'flex'}, flexGrow: 1}}>
                    <LogoSection/>
                </Box>



            </Box>

            {/* header search */}
            {/*<SearchSection />*/}
            <Box sx={{flexGrow: 1}}/>

            {/*<Box sx={{display: {xl: 'none', sm: 'block'}}}>*/}

            {/*    <Stack direction={'row'} spacing={1} justifyContent={'center'} alignItems={'center'} sx={{}}>*/}
            {/*        <InfoRounded fontSize={"small"} sx={{color: "#90caf9"}}/>*/}
            {/*        <Typography variant={"subtitle2"}>ID de dispositivo: {deviceId}</Typography>*/}
            {/*    </Stack>*/}
            {/*</Box>*/}

            <Box sx={{flexGrow: 1}}/>

            {/* notification & profile */}

            {/*<NotificationSection />*/}

            <ProfileSection/>
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
